import { connect } from 'react-redux';
import {
  highlightUserConsentErrorUpdate,
  initialiseGSTIN,
  stateUpdate,
  userConsentUpdate,
} from '../../Store/GSTINactions';
import GSTIN from './GSTIN';

const mapStateToProps = ({ gstinReducer }: any, ownProps: any) => {
  const {
    visibility,
    state,
    userConsent,
    highlightUserConsentError
  } = gstinReducer;
  return {
    ...ownProps,
    visibility,
    state,
    userConsent,
    highlightUserConsentError
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    initialise: (lob: string) => {
      dispatch(initialiseGSTIN(lob));
    },
    stateUpdate: (data: string) => {
      dispatch(stateUpdate(data));
    },
    userConsentUpdate: (data: boolean) => {
      dispatch(userConsentUpdate(data));
    },
    highlightUserConsentErrorUpdate: (data: boolean) => {
      dispatch(highlightUserConsentErrorUpdate(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GSTIN);